import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Legend, ReferenceDot,
} from 'recharts';
import { INDICATOR_COLORS, TRADE_ACTION_COLORS, fmtBarDate } from './utils';

// Shown separately for non-price-scale indicators (e.g. RSI) — only when there's
// no price series to overlay indicators onto directly.
export default function IndicatorsSection({ backtest }) {
  const indicatorSeries = backtest.indicator_series || {};
  const priceSeries = backtest.price_series || [];
  const tradeEvents = backtest.trade_events || [];
  const indicatorNames = Object.keys(indicatorSeries);

  let indicatorData = [];
  if (indicatorNames.length > 0) {
    const dateMap = {};
    indicatorNames.forEach((name) => {
      (indicatorSeries[name] || []).forEach(({ date, value }) => {
        if (!dateMap[date]) dateMap[date] = { date };
        dateMap[date][name] = value;
      });
    });
    indicatorData = Object.values(dateMap).sort((a, b) => a.date.localeCompare(b.date));
  }

  if (indicatorData.length === 0 || priceSeries.length > 0) return null;

  return (
    <>
      <h3 style={{ marginTop: 28, color: 'var(--text)' }}>Indicators</h3>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={indicatorData} margin={{ top: 5, right: 10, bottom: 0, left: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis dataKey="date" tick={{ fontSize: 10, fill: 'var(--muted)' }} interval="preserveStartEnd" tickFormatter={fmtBarDate} />
          <YAxis tick={{ fontSize: 11, fill: 'var(--muted)' }} domain={['auto', 'auto']} />
          <Tooltip contentStyle={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text)' }} />
          <Legend />
          {indicatorNames.map((name, i) => (
            <Line
              key={name}
              type="monotone"
              dataKey={name}
              stroke={INDICATOR_COLORS[i % INDICATOR_COLORS.length]}
              dot={false}
              name={name}
              strokeWidth={1.5}
            />
          ))}
          {tradeEvents.map((t, i) => {
            const row = indicatorData.find((d) => d.date === t.date);
            if (!row) return null;
            const firstInd = indicatorNames[0];
            const yVal = row[firstInd];
            if (yVal == null) return null;
            return (
              <ReferenceDot
                key={`ind-${i}`}
                x={t.date}
                y={yVal}
                r={4}
                fill={TRADE_ACTION_COLORS[t.action] || '#8b949e'}
                stroke="var(--bg)"
                strokeWidth={1.5}
                isFront
              />
            );
          })}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
}
